import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Button } from '../../components/Button';
import { ButtonBack } from '../../components/ButtonBack';
import { Card } from '../../components/Card';
import { HelmetComponent } from '../../components/Helmet';
import { List, ListItem } from '../../components/List';

import * as routes from '../../constants/Routes';
import { useAuth } from '../../hooks/useAuth';
import { api } from '../../server/api';

import avatar from '../../assets/images/avatar.png';

import step1Image from '../../assets/images/step-1.png';
import step2Image from '../../assets/images/step-2.png';
import step3Image from '../../assets/images/step-3.png';
import step4Image from '../../assets/images/step-4.png';
import { ModalTutorials } from './components/ModalTutorials';
import { Ranking } from './components/Ranking';
import PointsChart from './components/PointsChart';
import { IHistoricalPoints } from '../../interfaces/IHistoricalPoints';
import PointsCard from './components/PointsCard';
import { ProgramCard } from './components/ProgramCard';
import { useKPI } from '../../hooks/useKPI';
import PersonalNumberCard from './components/PersonalNumbersCard';

interface IProspects {
  name: string;
  email: string;
  phoneNumber?: string;
  leads?: string;
  id: string;
  photoURL: string;
}

export function Results() {
  const navigate = useNavigate();
  const { playerKPI, getPlayerKPI } = useKPI();
  const { client, player, getClientByAliasAndPlayer } = useAuth();
  const [closeDeals, setCloseDeals] = useState<number>(0);
  const [numberOfWinners, setNumberOfWinners] = useState<number>(0);
  const [distributedStations, setDistributedStations] = useState<number>(0);
  const [modalModalTutorialsIsOpen, setModalModalTutorialsIsOpen] =
    useState<boolean>(false);
  const [tutorial, setTutorial] = useState<any>();
  const [rankingList, setRankingList] = useState<any>([]);
  const [playersGuest, setPlayersGuest] = useState<Array<IProspects>>([]);
  const [historicalPoints, setHistoricalPoints] = useState<IHistoricalPoints>();
  const [isMdClient, setisMdClient] = useState<boolean>(false);
  const [isCuryClient, setisCuryClient] = useState<boolean>(false);

  const stepsListImages: Array<string> = [];

  useEffect(() => {
    if (client.steps.length === 2) {
      stepsListImages[0] = step1Image;
      stepsListImages[1] = step4Image;
    }

    if (client.steps.length === 3) {
      stepsListImages[0] = step1Image;
      stepsListImages[1] = step2Image;
      stepsListImages[2] = step4Image;
    }

    if (client.steps.length === 4) {
      stepsListImages[0] = step1Image;
      stepsListImages[1] = step2Image;
      stepsListImages[2] = step3Image;
      stepsListImages[3] = step4Image;
    }

    if (
      client &&
      client.mgmVinculated &&
      client.mgmVinculated === 'true' &&
      client.enableRankingRange &&
      client.enableRankingRange === 'true' &&
      player &&
      player.regional &&
      player.regional === 'sim'
    ) {
      getRankingCorrectors();
    }

    if (client && client?.settings?.multilevel?.enabled && player?.role) {
      getRankingByRole();
    }

    if (client && client.clientUrl === 'md') {
      setisMdClient(!isMdClient);
    }

    if (client && client.clientUrl === 'curyrio') {
      setisCuryClient(!isCuryClient);
    }

    getClosedDeals();
    getDistributedStations();
    getNumberOfWinners();
    getGamificationData();

    getPlayersGuest();
    getClientByAliasAndPlayer();
    getPlayerKPI(player.id);
  }, []);

  const getPlayersGuest = async () => {
    try {
      const parameters = {
        userType: 'player',
        searchFunctionality: 'getGuestPlayer',
        playerId: player.id,
        clientId: client.id,
      };

      const { data } = await api.post('/search', parameters);

      if (data.success) {
        const { playersGuest } = data.data;
        setPlayersGuest(playersGuest);
      }
    } catch (error) {
      console.log('getPlayersGuest error: ', error);
    }
  };

  async function getGamificationData() {
    try {
      const playerId = player.id;

      const { data } = await api.get(
        `/historical-points/group/step/${playerId}`
      );

      setHistoricalPoints(data.body);
    } catch (error) {
      console.log('getGamificationData error: ', error);
    }
  }

  const getRankingCorrectors = async () => {
    try {
      const parameters = {
        userType: 'player',
        searchFunctionality: 'getRankingCorrectors',
        clientId: client.id,
      };

      const { data } = await api.post('/search', parameters);

      if (data.success) {
        setRankingList(data.data);
      } else {
        setRankingList([]);
      }
    } catch (error) {
      console.log('getRankingCorrectors error: ', error);
    }
  };

  const getRankingByRole = async () => {
    try {
      const { data } = await api.get(
        `/clients/${client.clientUrl}/players-ranking?limit=300`
      );
      let rankingList = data.body.playersRankingOrder;

      if (rankingList.length > 0) {
        rankingList = filterRankingBasedOnHierarchy(rankingList);
        setRankingList(rankingList);
      } else {
        setRankingList([]);
      }
    } catch (error) {
      console.log('getRankingByRole error: ', error);
    }
  };

  const filterRankingBasedOnHierarchy = (rankingList: any[]) => {
    const role = player.role;
    const clientSettings = client?.settings?.multilevel;

    if (!clientSettings?.enabled) return rankingList;

    const playerLevel = clientSettings.levels.findIndex(
      (r: any) => r.role === role
    );

    if (playerLevel === -1) {
      return [];
    }

    return rankingList.filter((item: any) => {
      const itemLevel = clientSettings.levels.findIndex(
        (r: any) => r.role === item.role
      );

      return (
        itemLevel !== -1 &&
        itemLevel >= playerLevel &&
        itemLevel <= playerLevel + clientSettings.nOfLevels
      );
    });
  };

  const getClosedDeals = async () => {
    try {
      const parameters = {
        userType: 'player',
        searchFunctionality: 'getClosedDeals',
        clientId: client.id,
      };

      const { data } = await api.post('/search', parameters);

      if (data.success) {
        setCloseDeals(data.data);
      }
    } catch (error) {
      console.log('getClosedDeals erro: ', error);
    }
  };

  const getNumberOfWinners = async () => {
    try {
      const parameters = {
        userType: 'player',
        searchFunctionality: 'getNumberOfWinners',
        playerId: player.id,
        clientId: client.id,
      };

      const { data } = await api.post('/search', parameters);

      if (data.success) {
        setNumberOfWinners(data.data);
      }
    } catch (error) {
      console.log('getNumberOfWinners erro: ', error);
    }
  };

  const getDistributedStations = async () => {
    try {
      const parameters = {
        userType: 'player',
        searchFunctionality: 'getDistributedStations',
        playerId: player.id,
        clientId: client.id,
      };

      const { data } = await api.post('/search', parameters);
      if (data.success) {
        setDistributedStations(Number(data.data.toFixed(2)));
      }
    } catch (error) {
      console.log('getDistributedStations erro: ', error);
    }
  };

  const handleModalModalTutorials = (nameTutorial?: string) => {
    const clientTutorials =
      client && client.videoTutorials ? client.videoTutorials : null;
    if (clientTutorials) {
      const findTutorial =
        nameTutorial &&
        clientTutorials.find(
          (tuto: any) => tuto.name.toLowerCase() === nameTutorial.toLowerCase()
        );

      setTutorial(findTutorial);
      setModalModalTutorialsIsOpen(!modalModalTutorialsIsOpen);
    }
  };

  function formatNumberToCurrency(number: number) {
    // If the number is greater than or equal to 1 million
    if (number >= 1000000) {
      const millions = (number / 1000000).toFixed(1);
      return (
        'R$ ' +
        (millions.endsWith('.0') ? millions.slice(0, -2) + 'M' : millions + 'M')
      ); // If it's rounded, remove the ".0"
    }
    // If the number is greater than or equal to 1 thousand
    else if (number >= 1000) {
      const thousands = (number / 1000).toFixed(1);
      return (
        'R$ ' +
        (thousands.endsWith('.0')
          ? thousands.slice(0, -2) + 'K'
          : thousands + 'K')
      ); // If it's rounded, remove the ".0"
    }
    // If the number is less than 1 thousand
    else {
      return 'R$ ' + number.toFixed(2); // Keep two decimal places
    }
  }

  function calculatePercentage(partialValue: number, totalValue: number) {
    // Check if the values are valid
    if (isNaN(partialValue) || isNaN(totalValue) || totalValue === 0) {
      return 0; // If the values are not numbers or the total value is zero
    }

    // Calculate the percentage
    const percentage = (partialValue / totalValue) * 100;

    return Math.round(percentage); // Return the rounded percentage to the nearest integer
  }
  return (
    <>
      <HelmetComponent
        clientLogoURL={client?.logoURL}
        companyName={client?.companyName}
        clientFavicon={client?.favIcon}
        primaryColor={client?.primaryColor}
        secondaryColor={client?.secondaryColor}
        tabTitle={'Resultados'}
      />
      <div className="container">
        <div className="row">
          <div className="my-3">
            <ButtonBack title="Resultados" />
          </div>
        </div>
        {client?.resultsModals?.brokersRanking !== 'false' &&
          player?.regional === 'sim' && (
            <div className="row">
              <Ranking
                list={rankingList}
                playerRole={player?.role}
                clientSettings={client?.settings?.multilevel}
              />
            </div>
          )}
        {player?.regional === 'nao' && (
          <>
            <div className="mb-3 d-flex align-items-center justify-content-between">
              <p className="fw-semibold m-0">Seus números</p>
            </div>
            <div className="row">
              <PersonalNumberCard
                title="Pageviews"
                value={playerKPI?.playersPageviewCount}
                additionalText={'pessoas acessaram'}
              />
              <PersonalNumberCard
                title="Leads"
                value={playerKPI?.playersAmountOfLeads}
                additionalText={'cadastros gerados'}
              />
              <PersonalNumberCard
                title="Negócios"
                value={playerKPI?.playersAmountOfConversions}
                additionalText={'vendas realizadas'}
              />
            </div>
          </>
        )}

        {!isCuryClient && (
          <div className="mb-3 d-flex align-items-center justify-content-between">
            <p className="fw-semibold m-0">Resultados gerais do programa</p>
            {client?.resultsModals?.indicators !== 'false' && (
              <Link to={routes.MY_INDICATIONS}>
                <Button text="Indicados" color="primary" icon="people" />
              </Link>
            )}
          </div>
        )}

        {isMdClient &&
          player &&
          player.regional &&
          player.regional === 'sim' && (
            <div className="row">
              <div className="col-sm-12 col-lg-9">
                <div className="row">
                  <div className="col-sm-12 col-md-6">
                    <div className="mb-3">
                      <ProgramCard
                        title="Negócios fechados"
                        value={closeDeals}
                        icon="work_outline"
                        showTutorial={
                          client?.useTutorialResults === 'true' &&
                          client.videoTutorials?.[0]
                        }
                        tutorialIcon="lightbulb"
                        tutorialText="Como ganhar"
                        onTutorialClick={() =>
                          handleModalModalTutorials('howToWin')
                        }
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6">
                    <div className="mb-3">
                      <ProgramCard
                        title="Sua meta"
                        value={
                          player && player.sales?.monthlyGoalVgv
                            ? player.sales.monthlyGoalVgv
                            : player?.individualMeta || 0
                        }
                        icon="monetization_on"
                        showTutorial={
                          client?.useTutorialResults === 'true' &&
                          client.videoTutorials?.[0]
                        }
                        tutorialIcon="lightbulb"
                        tutorialText="Como ganhar"
                        onTutorialClick={() =>
                          handleModalModalTutorials('howToWin')
                        }
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6">
                    <div className="mb-3">
                      <ProgramCard
                        title="Suas vendas"
                        value={
                          player && player.sales?.totalVgv
                            ? player.sales.totalVgv
                            : player?.acumulativeMeta || 0
                        }
                        icon="account_balance"
                        showTutorial={
                          client?.useTutorialResults === 'true' &&
                          client.videoTutorials?.[0]
                        }
                        tutorialIcon="lightbulb"
                        tutorialText="Como ganhar"
                        onTutorialClick={() =>
                          handleModalModalTutorials('howToWin')
                        }
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6">
                    <div className="mb-3">
                      <ProgramCard
                        title="Seu desempenho"
                        value={calculatePercentage(
                          player?.sales?.totalVgv ||
                            player?.acumulativeMeta ||
                            0,
                          player?.sales?.monthlyGoalVgv ||
                            player?.individualMeta ||
                            1
                        )}
                        icon="trending_up"
                        showTutorial={
                          client?.useTutorialResults === 'true' &&
                          client.videoTutorials?.[0]
                        }
                        tutorialIcon="lightbulb"
                        tutorialText="Como ganhar"
                        onTutorialClick={() =>
                          handleModalModalTutorials('howToWin')
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-lg-3">
                <div className="mb-3">
                  <Card>
                    <p className="fw-semibold m-0 text-center">
                      Seu desempenho
                    </p>
                    <div className="d-flex flex-colums justify-content-center">
                      <div className="single-chart" style={{ width: '100px' }}>
                        <svg
                          viewBox="0 0 36 36"
                          className="circular-chart primary"
                        >
                          <path
                            className="circle-bg"
                            d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
                          />
                          <path
                            className="circle"
                            strokeDasharray={`${calculatePercentage(
                              player && player.sales?.totalVgv
                                ? player.sales?.totalVgv
                                : player && player.acumulativeMeta
                                  ? player.acumulativeMeta
                                  : 0,
                              player && player.sales?.monthlyGoalVgv
                                ? player.sales?.monthlyGoalVgv
                                : player && player.individualMeta
                                  ? player.individualMeta
                                  : 0
                            )}, 100`}
                            d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
                          />
                          <text
                            x="50%"
                            y="17"
                            style={{
                              dominantBaseline: 'middle',
                              textAnchor: 'middle',
                            }}
                            className="percentage"
                          >
                            {calculatePercentage(
                              player && player.sales?.totalVgv
                                ? player.sales?.totalVgv
                                : player && player.acumulativeMeta
                                  ? player.acumulativeMeta
                                  : 0,
                              player && player.sales?.monthlyGoalVgv
                                ? player.sales?.monthlyGoalVgv
                                : player && player.individualMeta
                                  ? player.individualMeta
                                  : 0
                            )}
                          </text>
                          <text
                            x="50%"
                            y="24"
                            style={{
                              dominantBaseline: 'middle',
                              textAnchor: 'middle',
                            }}
                            className="percentage-symbol"
                          >
                            por cento
                          </text>
                        </svg>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="d-flex align-items-center justify-content-center">
                          <div
                            className="rounded-circle bg-primary-color me-2"
                            style={{ width: '10px', height: '10px' }}
                          ></div>
                          <span className="text-nowrap tiny-text">
                            {player && player.sales?.monthlyGoalVgv
                              ? formatNumberToCurrency(
                                  player.sales?.monthlyGoalVgv
                                )
                              : formatNumberToCurrency(
                                  player && player.individualMeta
                                    ? player.individualMeta
                                    : 0
                                )}
                          </span>
                        </div>
                      </div>
                      <div className="col">
                        <div className="d-flex align-items-center justify-content-center">
                          <div
                            className="rounded-circle bg-primary-color me-2"
                            style={{ width: '10px', height: '10px' }}
                          ></div>
                          <span className="text-nowrap tiny-text">
                            {player && player.sales?.totalVgv
                              ? formatNumberToCurrency(player.sales?.totalVgv)
                              : formatNumberToCurrency(
                                  player && player.acumulativeMeta
                                    ? player.acumulativeMeta
                                    : 0
                                )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          )}

        {!isMdClient && !isCuryClient && (
          <div className="row">
            {client &&
              (client.clientUrl !== 'careplusclinic' ||
                client.clientUrl !== 'primeclinic') && (
                <div className="col-sm-12 col-md-3">
                  <div className="mb-3">
                    <ProgramCard
                      title="Negócios fechados"
                      value={closeDeals}
                      icon="work_outline"
                      showTutorial={
                        client?.useTutorialResults === 'true' &&
                        client.videoTutorials?.[0]
                      }
                      tutorialIcon="lightbulb"
                      tutorialText="Como ganhar"
                      onTutorialClick={() =>
                        handleModalModalTutorials('howToWin')
                      }
                    />
                  </div>
                </div>
              )}

            <div
              className={
                client &&
                (client.clientUrl !== 'careplusclinic' ||
                  client.clientUrl !== 'primeclinic')
                  ? 'col-sm-12 col-md-3'
                  : 'col-sm-12 col-md-6'
              }
            >
              <div className="mb-3">
                <ProgramCard
                  title={
                    client?.coinName
                      ? client.coinName.replace(
                          /\((\w+)\)/,
                          (_, conteudo) => conteudo
                        )
                      : 'Pontos' + ' distribuídos'
                  }
                  value={distributedStations}
                  icon="emoji_events"
                  showTutorial={
                    client?.useTutorialResults === 'true' &&
                    client.videoTutorials?.[1]
                  }
                  tutorialIcon="lightbulb"
                  tutorialText="Como ganhar"
                  onTutorialClick={() =>
                    handleModalModalTutorials('howtoRedeem')
                  }
                />
              </div>
            </div>
            <div
              className={
                client &&
                (client.clientUrl !== 'careplusclinic' ||
                  client.clientUrl !== 'primeclinic')
                  ? client &&
                    client.mgmVinculated &&
                    client.mgmVinculated === 'true' &&
                    player &&
                    player.regional === 'sim'
                    ? 'col-sm-12 col-md-3'
                    : 'col-sm-12 col-md-6'
                  : 'col-sm-12 col-md-6'
              }
            >
              <div className="mb-3">
                <ProgramCard
                  title="Nº Ganhadores"
                  value={numberOfWinners}
                  icon="group"
                  showTutorial={
                    client?.useTutorialResults === 'true' &&
                    client.videoTutorials?.[2]
                  }
                  tutorialIcon="lightbulb"
                  tutorialText="Como ganhar"
                  onTutorialClick={() =>
                    handleModalModalTutorials('testimonials')
                  }
                />
              </div>
            </div>
            {client &&
              client.mgmVinculated &&
              client.mgmVinculated === 'true' &&
              player &&
              player.regional === 'sim' && (
                <div className="col-sm-12 col-md-3">
                  <div className="mb-3">
                    <ProgramCard
                      title="Meta do mês"
                      value={client.scalePreset}
                      icon="trending_up"
                      additionalText="vendas"
                      showTutorial={true}
                      tutorialIcon="info"
                      tutorialText="Detalhes"
                      onTutorialClick={() => navigate(routes.MY_INDICATIONS)}
                    />
                  </div>
                </div>
              )}
          </div>
        )}
        {client?.resultsModals?.historyPoints !== 'false' && (
          <>
            <div className="mb-3">
              <p className="fw-semibold">
                Origem dos meus{' '}
                {client?.coinName
                  ? client.coinName.replace(
                      /\((\w+)\)/,
                      (_, conteudo) => conteudo
                    )
                  : 'pontos'}
              </p>
            </div>
            <div className="col-sm-12">
              <div className="mb-3">
                <Card>
                  <PointsChart {...historicalPoints} />
                </Card>
              </div>
            </div>
            <div className="row">
              {/* Broker Steps */}
              {client?.brokerSteps?.map((step, index) => (
                <PointsCard
                  key={`broker-${index}`}
                  title={step.name}
                  defaultName="Broker"
                  index={index}
                  value={
                    historicalPoints?.pointsOrigin?.webhookBrokerPoints?.[
                      index + 1
                    ]
                  }
                />
              ))}

              {/* Webhook Steps */}
              {client?.steps?.map((step, index) => (
                <PointsCard
                  key={`webhook-${index}`}
                  title={step.name}
                  defaultName="Webhook"
                  index={index}
                  value={
                    historicalPoints?.pointsOrigin?.advancedStepLead?.[
                      index + 1
                    ]
                  }
                />
              ))}

              {/* Quiz */}
              <PointsCard
                key="quiz"
                title="Quiz"
                value={historicalPoints?.pointsOrigin?.quiz}
              />

              {/* Research Award */}
              <PointsCard
                key="research"
                title="Pesquisas"
                value={historicalPoints?.pointsOrigin?.researchAward}
              />

              {/* Sales Conversion */}
              <PointsCard
                key="sales"
                title="Conversão"
                value={historicalPoints?.pointsOrigin?.salesConversion}
              />

              {/* Extra Points */}
              <PointsCard
                key="extra"
                title="Pontos extras"
                value={historicalPoints?.pointsOrigin?.extraPoints}
              />

              {/* Lead Registration */}
              <PointsCard
                key="leads"
                title="Leads"
                value={historicalPoints?.pointsOrigin?.leadRegistration}
              />

              {/* Member Get Member */}
              <PointsCard
                key="member"
                title="Seus convidados"
                value={historicalPoints?.pointsOrigin?.membergetmember}
              />

              {/* Total Points */}
              <PointsCard
                key="total"
                title={
                  client?.coinName
                    ? client.coinName.replace(
                        /\((\w+)\)/,
                        (_, conteudo) => conteudo
                      )
                    : 'Pontos totais'
                }
                value={historicalPoints?.totalPoints}
              />
            </div>
          </>
        )}

        {client?.resultsModals?.prospectors !== 'false' &&
          player?.regional === 'sim' && (
            <div className="row">
              <div className="col-sm-12 col-md-12"></div>
              <div className="col-sm-12">
                <div className="mb-3">
                  <Card>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className="fw-semibold">Meus prospectores</span>
                      <Link to={routes.PROSPECTS}>
                        <Button text="Ver mais" icon="add" color="flat" />
                      </Link>
                    </div>
                    <hr />
                    <List>
                      {playersGuest && playersGuest.length > 0 ? (
                        playersGuest
                          .slice(0, 5)
                          .map((player, index) => (
                            <ListItem
                              key={index}
                              image={player.photoURL ? player.photoURL : avatar}
                              content={player.name}
                            />
                          ))
                      ) : (
                        <ListItem
                          icon="hourglass_empty"
                          content="Nada por aqui."
                        />
                      )}
                    </List>
                  </Card>
                </div>
              </div>
            </div>
          )}
      </div>
      <ModalTutorials
        modalIsOpen={modalModalTutorialsIsOpen}
        toggleModalIsOpen={() => handleModalModalTutorials('')}
        tutorial={tutorial}
      />
    </>
  );
}
